import { render } from "./Camera.vue?vue&type=template&id=afaeff2a"
const script = {}
script.render = render

export default script